import React from "react";
import PostReviewDetail from "../../features/Resources/PostReviewDetail";

const PostReview = () => {
  return (
    <div>
      <PostReviewDetail />
    </div>
  );
};

export default PostReview;
